<div class="map custom-map12" #mapElement>
</div>
<div class="flex map-btn justify-content-end mb-4">
    <p-button label="Save Location" (onClick)="selectLocation()"></p-button>
    <p-button label="Cancel" styleClass="p-button-outlined ml-2" (onClick)="cancel()"></p-button>
</div>